import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DatePickerModule } from "primeng/datepicker";
import { SelectModule } from "primeng/select";
import { CheckboxWrapComponent } from "src/app/shared/components/ui/checkbox-wrap.component";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { DataElement } from "src/app/shared/models/common";
import { DrProfile, DrProfilePref } from "src/app/shared/models/order.model";
import { techiniciansList } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";

@Component({
  selector: "edit-profile-pg",
  templateUrl: "./edit-profile-pg.component.html",
  styleUrls: ["./edit-profile-pg.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    ClearMultiComponent,
    DatePickerModule,
    CheckboxWrapComponent,
  ],
  standalone: true,
})
export class EditProfilePgComponent {
  @Input() profile: DrProfile;

  technician: DataElement;
  pgSw: boolean;
  pgSnoozeDate: Date;
  calLocale = {};

  get techniciansList(): DataElement[] {
    return this.store.selectSignal(techiniciansList)();
  }

  constructor(
    private readonly store: Store,
    private translateService: TranslateService
  ) {
    this.translateService.get("calLocale").subscribe((data) => {
      this.calLocale = data;
    });
  }

  ngOnInit(): void {
    let pref = this.profile.pref.find((p) => p.prefType == "PERSONAL_GUIDANCE");
    this.technician = pref?.technician;
  }

  save() {
    let pref = this.profile.pref.find((p) => p.prefType == "PERSONAL_GUIDANCE");

    if (this.technician) {
      if (pref) {
        pref.technician = this.technician;
        pref.pgSw = this.pgSw;
        pref.pgSnoozeDate = this.pgSnoozeDate;
      } else {
        let newPref = new DrProfilePref();
        newPref.prefType = "PERSONAL_GUIDANCE";
        newPref.technician = this.technician;
        newPref.pgSw = this.pgSw;
        newPref.pgSnoozeDate = this.pgSnoozeDate;
        this.profile.pref.push(newPref);
      }
    } else if (pref) {
      this.profile.pref.splice(this.profile.pref.indexOf(pref), 1);
    }
  }

  clearPG() {
    this.technician = null;
    this.pgSnoozeDate = null;
    this.pgSw = false;
  }
}
